import React from 'react'
import { Switch, Redirect } from 'react-router-dom'
import RouteWithSubRoutes from './RouteWithSubRoutes'
import { IRoute } from './config'
import { DEFAULT_AUTHENTICATED_ROUTE } from '../utils/env'

interface IProps {
  routes: IRoute[]
}

const Router: React.FC<IProps> = ({ routes }) => {
  return (
    <Switch>
      {routes.map((route: IRoute) => (
        <RouteWithSubRoutes key={route.path} {...route} />
      ))}
      <Redirect to={DEFAULT_AUTHENTICATED_ROUTE} />
    </Switch>
  )
}

export default Router
